import { lazy } from 'react';

export const GlobalPlayerAccountStatusForm = lazy(
  () => import('./GlobalPlayerAccountStatusForm'),
);
